import React, { useRef, useState, useEffect } from 'react';
import { Tooltip } from 'antd';

export const SmartSingleLine = ({ children }) => {
  const textRef = useRef(null);
  const [isOverflow, setIsOverflow] = useState(false);

  useEffect(() => {
    const checkOverflow = () => {
      const el = textRef.current;
      if (el) {
        setIsOverflow(el.scrollWidth > el.clientWidth);
      }
    };

    // 初次渲染时检测是否溢出
    checkOverflow();

    // 窗口大小变化时重新检测
    window.addEventListener('resize', checkOverflow);
    return () => {
      window.removeEventListener('resize', checkOverflow);
    };
  }, [children]);

  const textStyle = {
    whiteSpace: 'nowrap',       // 强制单行显示
    overflow: 'hidden',         // 隐藏溢出的部分
    textOverflow: 'ellipsis',   // 显示省略号
    maxWidth: '100%',           // 确保不会超过父容器
  };

  return (
    <Tooltip title={isOverflow ? children : ''} placement="top">
      <div ref={textRef} style={textStyle}>
        {children}
      </div>
    </Tooltip>
  );
};



// WEBPACK FOOTER //
// ./src/components/SmartSingleLine/index.js